import React from "react";
import moment from "moment";
import { formatWrittenDateTimeUtc } from "utilities";
import { routes } from "utilities/routing/generatedRoutes";
import { UserAvatar } from "components/Atoms/Avatar";

interface CheatingReprimandItem {
  cheatingReprimand: server.dto.CheatingReprimand
}

const CheatingReprimandRowCard = ({ cheatingReprimand }: CheatingReprimandItem) => {
  const { user, timestampUtc } = cheatingReprimand;

  return (
    <div className="radius hoverable" onClick={() => {
      document.location.href = routes.user_DetailAdminOne(user.userId).absolute;
    }}>
      <div>
        <UserAvatar user={user} />
      </div>
      <div className="grow1">
        {user.fullName}
      </div>
      <div style={{ textAlign: "right" }} className="s1_gray">
        {formatWrittenDateTimeUtc(moment.utc(timestampUtc))}
      </div>
    </div>
  );
};

export default CheatingReprimandRowCard;
